import React, { useState, useRef, useEffect } from 'react'
import {
	Card,
	CardHeader,
	CardContent,
	Checkbox,
	FormControlLabel,
	makeStyles,
	TextField,
	Typography,
	MenuItem,
	CardActions,
	Button,
	IconButton,
	Icon,
	ListItemText,
	Chip,
	ButtonBase
} from '@material-ui/core'

import clsx from 'clsx'
import { sendPasswordResetEmail } from 'firebase/auth'
import { api } from '../../../services/api'

import { showError, showSuccess } from '../../../actions/misc/misc.actions'

import { KeyboardDatePicker, DatePicker } from '@material-ui/pickers'

import { ArrowForwardIosOutlined, ArrowBackIosOutlined } from '@material-ui/icons'

import { withFirebaseHOC } from '../../Firebase/context'
import { useDispatch } from 'react-redux'
import ActivationDialog from '../../Dialogs/Contacts/ActivationDialog'
import DeactivationDialog from '../../Dialogs/Contacts/DeactivationDialog'
import ReactivationDialog from '../../Dialogs/Contacts/ReactivationDialog'

import MaskedInput from 'react-text-mask'
import moment from 'moment'
import { states } from '../../../services/helpers'
import Autocomplete from '@material-ui/lab/Autocomplete'
import { uploadIdInfoFile } from '../../../actions/accounts/accounts.actions'
import StyledAlert from '../../Common/StyledAlert'

function TextMaskCustom(props) {
	const { inputRef, ...other } = props

	return (
		<MaskedInput
			{...other}
			ref={(ref) => {
				inputRef(ref ? ref.inputElement : null)
			}}
			mask={['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
			placeholderChar={'\u2000'}
			showMask
		/>
	)
}

const useStyles = makeStyles((theme) => ({
	grid: {
		display: 'grid',
		gridGap: '23px',
		marginBottom: '23px',
		'&:last-child': {
			marginBottom: 0
		}
	},
	gridDouble: {
		gridTemplateColumns: 'repeat(auto-fill, minmax(424px, 1fr))',
		'& .field-wrapper': {
			'& .MuiTextField-root': {
				minWidth: '424px !important'
			}
		}
	},
	gridTriple: {
		gridTemplateColumns: 'repeat(auto-fill, minmax(274px, 1fr))',
		'& .field-wrapper': {
			'& .MuiTextField-root': {
				minWidth: '274px !important'
			}
		}
	},
	input: {
		display: 'none'
	},
	datePicker: {
		marginTop: 0,
		'& .MuiInputLabel-filled': {
			transform: 'translate(12px, 20px) scale(1)'
		},
		'&:nth-child(1)': {
			marginRight: '16px !important'
		},
		'& .MuiInputLabel-root': {
			textOverflow: 'ellipsis',
			whiteSpace: 'nowrap',
			maxWidth: 200,
			overflow: 'hidden'
		},
		'& .MuiInputLabel-shrink': {
			maxWidth: 274,
			transform: 'translate(12px, 10px) scale(0.75)'
		}
	},
	calendarButton: {
		'& svg': {
			fill: theme.palette.primary.main
		}
	},
	calendarHeaderButtons: {
		fill: theme.palette.primary.main
	},
	popover: {
		'& .MuiMenu-paper': {
			borderRadius: 6,
			boxShadow: '0px 2px 15px rgba(26, 26, 53, 0.2)'
		}
	},
	actions: {
		display: 'flex',
		justifyContent: 'space-between'
	},
	deleteButton: {
		color: '#D32F2F',
		borderColor: '#D32F2F',
		'&:hover': {
			color: '#FFFFFF',
			backgroundColor: '#D32F2F'
		}
	},
	subTitle: {
		marginBottom: '16px',
		fontSize: '16px',
		fontWeight: '800'
	},
	autoComplete: {
		'& .MuiFilledInput-root': {
			paddingTop: '17px'
		},
		'& .MuiInputLabel-filled': {
			transform: 'translate(12px, 20px) scale(1)'
		},
		'& .Mui-focused': {
			'& .MuiAutocomplete-endAdornment svg': {
				fill: theme.palette.secondary.main
			}
		},
		'& .MuiAutocomplete-endAdornment svg': {
			fill: '#777679'
		}
	},
	chip: {
		padding: '12px 0px 12px 16px',
		height: '48px',
		marginRight: 10,
		backgroundColor: '#F9F9F9',
		'& .MuiChip-label': {
			fontWeight: 800,
			fontSize: '14px',
			lineHeight: '19px',
			letterSpacing: 1.25,
			textTransform: 'uppercase',
			color: '#6B4AD6',
			marginRight: 30
		},
		'& .fas': {
			fontSize: '16px',
			marginRight: 8,
			lineHeight: '18px',
			color: '#6B4AD6'
		}
	},
	trackedDataWrapper: {
		width: '100%',
		background: '#F9F9F9',
		borderRadius: '6px',
		marginBottom: '24px'
	},
	trackedData: {
		maxWidth: '619px',
		display: 'flex',
		justifyContent: 'space-between',
		padding: '24px 23px',
		'& .section:not(:first-child)': {
			paddingLeft: '24px',
			position: 'relative',
			'&:not(:first-child):before': {
				content: "''",
				height: '100%',
				width: '1px',
				position: 'absolute',
				top: 0,
				left: '0px',
				background: '#D0CFD2'
			}
		}
	},
	data: {
		fontSize: '22px',
		fontWeight: 800,
		lineHeight: '30px',
		textTransform: 'uppercase'
	}
}))

const Contact = (props) => {
	const classes = useStyles()
	const dispatch = useDispatch()
	const selectRef = useRef(null)
	const idInputRef = useRef(null)
	const waiverInputRef = useRef(null)

	let {
		contact,
		index,
		updateAccount,
		removeAccount,
		activateAccount,
		deactivateAccount,
		firebase,
		firebaseDisabled,
		pets
	} = props

	const [origin, setOrigin] = useState(0)
	const [isActivationDialogShown, setIsActivationDialogShown] = useState(false)
	const [isCalendarOpen, setIsCalendarOpen] = useState(false)
	const [isExpirationCalendarOpen, setIsExpirationCalendarOpen] = useState(false)
	const [isDeactivationDialogShown, setIsDeactivationDialogShown] = useState(false)
	const [isReactivationDialogShown, setIsReactivationDialogShown] = useState(false)
	// const [isWaiverExpirationCalendarOpen, setIsWaiverExpirationCalendarOpen] = useState(false)
	// const [isDuesCalendarOpen, setIsDuesCalendarOpen] = useState(false)
	// const [waiverValue, setWaiverValue] = useState('Expired')
	const [duesValue, setDuesValue] = useState('Unpaid')
	const [firebaseAccountDisabled, setFirebaseAccountDisabled] = useState(false)
	const [busy, setBusy] = useState(false)

	useEffect(() => {
		setFirebaseAccountDisabled(firebaseDisabled)
	}, [firebaseDisabled])

	useEffect(() => {
		// if (contact?.ID_info?.waiver_expiration_date) {
		// 	let date = moment(contact?.ID_info?.waiver_expiration_date).format('MM-DD-YY')
		// 	let today = moment().format('MM-DD-YY')
		// 	if (moment(date).isSameOrAfter(moment(today))) {
		// 		setWaiverValue('Valid')
		// 	} else {
		// 		setWaiverValue('Expired')
		// 	}
		// } else {
		// 	setWaiverValue('Expired')
		// }

		if (contact?.ID_info?.date_dues_paid) {
			let date = moment(contact?.ID_info?.date_dues_paid).format('MM-DD-YY')
			let today = moment().format('MM-DD-YY')
			let diff = moment(date).diff(moment(), 'days')
			if (Math.abs(diff) > 365) {
				setDuesValue('Unpaid')
			} else {
				setDuesValue('Paid')
			}
		} else {
			setDuesValue('Unpaid')
		}
	}, [contact])

	const getTransformOrigin = (e) => {
		let select = selectRef

		if (select.current) {
			setOrigin(index === 0 ? select.current.offsetHeight : select.current.offsetHeight + 40)
		}
	}

	const confirmActivation = () => {
		setIsActivationDialogShown(false)
		setIsReactivationDialogShown(false)
		activateAccount(contact)
	}

	const confirmDeactivation = () => {
		setIsDeactivationDialogShown(false)
		deactivateAccount(contact)
	}

	const sendPasswordReset = async () => {
		try {
			await sendPasswordResetEmail(firebase.clientAuth, contact.email)
			dispatch(showSuccess('Password Reset Link was sent.'))
		} catch (e) {
			dispatch(showError('Password Reset Link failed to send.'))
		}
	}

	const uploadFile = (e, key) => {
		let file

		if (e.target.files && e.target.files.length && e.target.files[0]) {
			file = e.target.files[0]

			const data = new FormData()
			data.append('legal_doc', file)

			dispatch(uploadIdInfoFile(contact._id, key, data)).then(() => {
				if (waiverInputRef && waiverInputRef.current) waiverInputRef.current.value = null
				if (idInputRef && idInputRef.current) idInputRef.current.value = null
			})
		}
	}

	const handleEnableFirebaseAccount = async () => {
		try {
			setBusy(true)
			const payload = { updates: { disabled: false } }
			const { data } = await api.patch(`/accounts/${contact._id}/updateFirebaseAccount`, payload)
			if (data.data && data.data.length > 0) {
				const info = data.data[0]
				setFirebaseAccountDisabled(info?.disabled)
			}
			if (data.errors && data.errors.length > 0) {
				console.log('error updating firebase status for account', data.errors[0])
			}
		} catch (e) {
			console.log('error updating firebase status for account', e)
		} finally {
			setBusy(false)
		}
	}

	// Adding some comments to help the file update
	return (
		<Card>
			<CardHeader title={contact.primary ? 'Primary' : 'Additional Contact'} />
			<CardContent>
				{!contact.uid && contact.active ? (
					<StyledAlert
						type="warning"
						text="This account's uid is not linked in the database."
						style={{ marginBottom: '1rem' }}
					/>
				) : null}
				{firebaseAccountDisabled ? (
					<StyledAlert
						type="warning"
						text="Firebase account is disabled"
						style={{ marginBottom: '1rem' }}
					/>
				) : null}
				<div className={classes.trackedDataWrapper}>
					<div className={classes.trackedData}>
						<div className="section">
							<Typography
								style={{
									lineHeight: '16px',
									marginBottom: '4px'
								}}
								variant="overline">
								First Signed up
							</Typography>
							{contact ? (
								<Typography className={classes.data}>
									{contact.createdAt ? moment(contact.createdAt).format('MM/DD/YYYY') : '--'}
								</Typography>
							) : null}
						</div>
						<div className="section">
							<Typography
								style={{
									lineHeight: '16px',
									marginBottom: '4px'
								}}
								variant="overline">
								Last App Open
							</Typography>
							{contact ? (
								<Typography className={classes.data}>
									{contact.last_opened ? moment(contact.last_opened).format('MM/DD/YYYY') : '--'}
								</Typography>
							) : null}
						</div>
						<div className="section">
							<Typography
								style={{
									lineHeight: '16px',
									marginBottom: '4px'
								}}
								variant="overline">
								Device Type
							</Typography>
							{contact ? (
								<Typography className={classes.data}>
									{contact.device_type ? contact.device_type : '--'}
								</Typography>
							) : null}
						</div>
					</div>
				</div>
				<Typography className={classes.subTitle}>Contact</Typography>
				<div className={clsx([classes.grid, classes.gridTriple])}>
					<div className={clsx([classes.fieldWrapper, 'field-wrapper'])}>
						<TextField
							label="First Name *"
							variant="filled"
							value={contact.first_name}
							onChange={(e) => updateAccount(contact, 'first_name', e.target.value)}
						/>
					</div>
					<div className={clsx([classes.fieldWrapper, 'field-wrapper'])}>
						<TextField
							label="Last Name *"
							variant="filled"
							value={contact.last_name}
							onChange={(e) => updateAccount(contact, 'last_name', e.target.value)}
						/>
					</div>
					<div className={clsx([classes.fieldWrapper, 'field-wrapper'])}>
						<TextField
							label="Phone"
							variant="filled"
							value={contact.phone_number}
							InputProps={{
								inputComponent:
									contact.phone_number && !contact.phone_number.includes('DELETED')
										? TextMaskCustom
										: undefined
							}}
							onChange={(e) => updateAccount(contact, 'phone_number', e.target.value)}
						/>
					</div>
				</div>
				<div>
					<div className={classes.fieldWrapper}>
						<TextField
							label="Email *"
							variant="filled"
							fullWidth
							value={contact.email}
							onChange={(e) => updateAccount(contact, 'email', e.target.value)}
						/>
					</div>
				</div>
				<div style={{ marginTop: 24 }}>
					{!contact.primary ? (
						<FormControlLabel
							control={
								<Checkbox
									checked={contact.makePrimary}
									onChange={(e) => updateAccount(contact, 'makePrimary', e.target.checked)}
								/>
							}
							label="Make primary contact"
						/>
					) : null}
				</div>
				<div className={clsx([classes.grid, classes.gridTriple])}></div>
				<div className={clsx([classes.grid, classes.gridDouble])}>
					<div className={clsx([classes.fieldWrapper, 'field-wrapper'])}>
						<TextField
							label="Personal Promo"
							variant="filled"
							value={contact.promo_code}
							onChange={(e) => updateAccount(contact, 'promo_code', e.target.value)}
						/>
					</div>
					<div className={clsx([classes.fieldWrapper, 'field-wrapper'])}>
						<TextField
							label="Agreement Status"
							variant="filled"
							select
							ref={selectRef}
							value={contact.terms_of_service || false}
							SelectProps={{
								onOpen: (e) => getTransformOrigin(e),
								MenuProps: {
									className: classes.popover,
									transformOrigin: { vertical: -origin, horizontal: 'left' }
								}
							}}
							onChange={(e) => updateAccount(contact, 'terms_of_service', e.target.value)}>
							<MenuItem value={true}>Confirmed</MenuItem>
							<MenuItem value={false}>Unconfirmed</MenuItem>
						</TextField>
					</div>
				</div>
				{contact._id ? (
					<div>
						<Typography className={classes.subTitle}>Photo ID & Waiver</Typography>
						<div
							style={{
								display: 'flex',
								marginBottom: 24
							}}>
							{!contact.ID_info || !contact.ID_info.signature_link ? (
								<div className={classes.fileUpload}>
									<input
										accept="image/*, application/pdf"
										className={classes.input}
										id={`waiver-file-input-${contact._id}`}
										type="file"
										ref={waiverInputRef}
										onChange={(e) => uploadFile(e, 'signature_link')}
									/>
									<label
										htmlFor={`waiver-file-input-${contact._id}`}
										style={{ position: 'relative' }}>
										<ButtonBase component="span">
											<Chip
												icon={<Icon className="fas fa-file" />}
												className={classes.chip}
												label="Signed Waiver"
												onDelete={() => null}
												deleteIcon={
													<Icon
														style={{ cursor: 'default' }}
														className="fas fa-arrow-to-top"
													/>
												}
											/>
										</ButtonBase>
									</label>
								</div>
							) : (
								<Chip
									className={classes.chip}
									icon={<Icon className="fas fa-file" />}
									deleteIcon={<Icon className="fas fa-times" />}
									{...{
										onDelete: () =>
											updateAccount(contact, 'ID_info', {
												...contact.ID_info,
												signature_link: ''
											}),
										onClick: () => {
											let url = contact.ID_info.signature_link || ''
											if (!url.match(/^https?:\/\//i)) {
												url = 'https://' + url
											}

											window.open(url, '_blank')
										}
									}}
									label="Signed Waiver"
								/>
							)}
							{!contact.ID_info || !contact.ID_info.image_link ? (
								<div className={classes.fileUpload}>
									<input
										accept="image/*, application/pdf"
										className={classes.input}
										id={`id-file-input-${contact._id}`}
										type="file"
										ref={idInputRef}
										onChange={(e) => uploadFile(e, 'image_link')}
									/>
									<label
										htmlFor={`id-file-input-${contact._id}`}
										style={{ position: 'relative' }}>
										<ButtonBase component="span">
											<Chip
												icon={<Icon className="fas fa-image" />}
												className={classes.chip}
												label="Photo ID"
												onDelete={() => null}
												deleteIcon={
													<Icon
														style={{ cursor: 'default' }}
														className="fas fa-arrow-to-top"
													/>
												}
											/>
										</ButtonBase>
									</label>
								</div>
							) : (
								<Chip
									className={classes.chip}
									icon={<Icon className="fas fa-file" />}
									deleteIcon={<Icon className="fas fa-times" />}
									{...{
										onDelete: () =>
											updateAccount(contact, 'ID_info', {
												...contact.ID_info,
												image_link: ''
											}),
										onClick: () => {
											let url = contact.ID_info.image_link || ''
											if (!url.match(/^https?:\/\//i)) {
												url = 'https://' + url
											}

											window.open(url, '_blank')
										}
									}}
									label="Photo ID"
								/>
							)}
						</div>
						<Typography className={classes.subTitle} style={{ fontSize: '12px' }}>
							IMPORTED ID FIELDS
						</Typography>
						<div className={clsx([classes.grid, classes.gridTriple])}>
							<div className={clsx([classes.fieldWrapper, 'field-wrapper'])}>
								<TextField
									label="First Name"
									onChange={(e) =>
										updateAccount(contact, 'ID_info', {
											...contact.ID_info,
											first_name: e.target.value
										})
									}
									variant="filled"
									value={
										contact.ID_info && contact.ID_info.first_name
											? contact.ID_info.first_name
											: ''
									}
								/>
							</div>
							<div className={clsx([classes.fieldWrapper, 'field-wrapper'])}>
								<TextField
									label="Last Name"
									onChange={(e) =>
										updateAccount(contact, 'ID_info', {
											...contact.ID_info,
											last_name: e.target.value
										})
									}
									variant="filled"
									value={
										contact.ID_info && contact.ID_info.last_name
											? contact.ID_info.last_name
											: ''
									}
								/>
							</div>
							<div className={clsx([classes.fieldWrapper, 'field-wrapper'])}>
								<KeyboardDatePicker
									disableFuture
									openTo="year"
									open={isCalendarOpen}
									onOpen={() => setIsCalendarOpen(true)}
									onClose={() => setIsCalendarOpen(false)}
									InputAdornmentProps={{
										position: 'end',
										component: () => (
											<IconButton onClick={() => setIsCalendarOpen(true)}>
												<Icon
													className="fas fa-calendar"
													style={{
														fontSize: '1.325rem'
													}}
												/>
											</IconButton>
										)
									}}
									variant="inline"
									format="MM/DD/YYYY"
									margin="normal"
									label="Birth Date"
									inputVariant="filled"
									views={['year', 'month', 'date']}
									value={
										contact.ID_info && contact.ID_info.birthday
											? moment.utc(contact.ID_info.birthday).format('M/D/YYYY')
											: null
									}
									onChange={(date) =>
										updateAccount(contact, 'ID_info', {
											...contact.ID_info,
											birthday: date
										})
									}
									className={classes.datePicker}
									rightArrowIcon={
										<ArrowForwardIosOutlined className={classes.calendarHeaderButtons} />
									}
									leftArrowIcon={
										<ArrowBackIosOutlined className={classes.calendarHeaderButtons} />
									}
									KeyboardButtonProps={{
										'aria-label': 'Start Date',
										className: classes.calendarButton
									}}
								/>
							</div>
							<div className={clsx([classes.fieldWrapper, 'field-wrapper'])}>
								<KeyboardDatePicker
									open={isExpirationCalendarOpen}
									onOpen={() => setIsExpirationCalendarOpen(true)}
									onClose={() => setIsExpirationCalendarOpen(false)}
									InputAdornmentProps={{
										position: 'end',
										component: () => (
											<IconButton onClick={() => setIsExpirationCalendarOpen(true)}>
												<Icon
													className="fas fa-calendar"
													style={{
														fontSize: '1.325rem'
													}}
												/>
											</IconButton>
										)
									}}
									variant="inline"
									format="MM/DD/YYYY"
									margin="normal"
									label="Expiration Date"
									inputVariant="filled"
									openTo="year"
									views={['year', 'month']}
									value={
										contact.ID_info && contact.ID_info.expiration_date
											? contact.ID_info.expiration_date
											: null
									}
									onChange={(date) =>
										updateAccount(contact, 'ID_info', {
											...contact.ID_info,
											expiration_date: date
										})
									}
									className={classes.datePicker}
									rightArrowIcon={
										<ArrowForwardIosOutlined className={classes.calendarHeaderButtons} />
									}
									leftArrowIcon={
										<ArrowBackIosOutlined className={classes.calendarHeaderButtons} />
									}
									KeyboardButtonProps={{
										'aria-label': 'Start Date',
										className: classes.calendarButton
									}}
								/>
							</div>
							<div className={clsx([classes.fieldWrapper, 'field-wrapper'])}>
								<TextField
									label="Gender"
									onChange={(e) =>
										updateAccount(contact, 'ID_info', {
											...contact.ID_info,
											gender: e.target.value
										})
									}
									variant="filled"
									value={contact.ID_info && contact.ID_info.gender ? contact.ID_info.gender : ''}
								/>
							</div>
							<div className={clsx([classes.fieldWrapper, 'field-wrapper'])}>
								<Autocomplete
									size="small"
									getOptionLabel={(option) => (option ? option.name : '')}
									id="household-select"
									className={classes.autoComplete}
									options={states || []}
									value={
										contact.ID_info && contact.ID_info.state
											? states.find((s) => s.abbreviation === contact.ID_info.state)
											: ''
									}
									onChange={(e, v, r) =>
										r === 'clear' && !v
											? null
											: updateAccount(contact, 'ID_info', {
													...contact.ID_info,
													state: v.abbreviation
											  })
									}
									onClose={(e) => {
										e.target.value = ''
									}}
									renderOption={(option) => (
										<React.Fragment>
											<ListItemText primary={option.name} />
										</React.Fragment>
									)}
									renderInput={(params) => (
										<TextField {...params} variant="filled" label="State" />
									)}
									onKeyPress={(e, v) =>
										e && e.key === 'Enter'
											? updateAccount(contact, 'ID_info', {
													...contact.ID_info,
													state: v
											  })
											: null
									}
								/>
							</div>
							{/* <div className={clsx([classes.fieldWrapper, 'field-wrapper'])}>
								<KeyboardDatePicker
									open={isWaiverExpirationCalendarOpen}
									onOpen={() => setIsWaiverExpirationCalendarOpen(true)}
									onClose={() => setIsWaiverExpirationCalendarOpen(false)}
									InputAdornmentProps={{
										position: 'end',
										component: () => (
											<IconButton onClick={() => setIsWaiverExpirationCalendarOpen(true)}>
												<Icon
													className="fas fa-calendar"
													style={{
														fontSize: '1.325rem'
													}}
												/>
											</IconButton>
										)
									}}
									variant="inline"
									format="MM/DD/YY"
									margin="normal"
									label="Waiver & Survey Signed Date"
									inputVariant="filled"
									required
									value={
										contact.ID_info && contact.ID_info.waiver_sign_date
											? contact.ID_info.waiver_sign_date
											: null
									}
									onChange={(date) =>
										updateAccount(contact, 'ID_info', {
											...contact.ID_info,
											waiver_sign_date: date,
											waiver_expiration_date: moment(date).add(1, 'year').toDate()
										})
									}
									className={classes.datePicker}
									rightArrowIcon={
										<ArrowForwardIosOutlined className={classes.calendarHeaderButtons} />
									}
									leftArrowIcon={
										<ArrowBackIosOutlined className={classes.calendarHeaderButtons} />
									}
									KeyboardButtonProps={{
										'aria-label': 'Start Date',
										className: classes.calendarButton
									}}
								/>
							</div> */}
							{/*<div className={clsx([classes.fieldWrapper, 'field-wrapper'])}>
								<TextField
									label="Waiver & Survey Signed Status"
									variant="filled"
									fullWidth
									disabled
									value={waiverValue}
								/>
							</div>*/}
							{/*<div className={clsx([classes.fieldWrapper, 'field-wrapper'])}>
								<KeyboardDatePicker
									open={isDuesCalendarOpen}
									onOpen={() => setIsDuesCalendarOpen(true)}
									onClose={() => setIsDuesCalendarOpen(false)}
									InputAdornmentProps={{
										position: 'end',
										component: () => (
											<IconButton onClick={() => setIsDuesCalendarOpen(true)}>
												<Icon
													className="fas fa-calendar"
													style={{
														fontSize: '1.325rem'
													}}
												/>
											</IconButton>
										)
									}}
									variant="inline"
									format="MM/DD/YY"
									margin="normal"
									label="Annual Dues Paid Date"
									inputVariant="filled"
									required
									value={
										contact.ID_info && contact.ID_info.date_dues_paid
											? contact.ID_info.date_dues_paid
											: null
									}
									onChange={(date) =>
										updateAccount(contact, 'ID_info', {
											...contact.ID_info,
											date_dues_paid: date
										})
									}
									className={classes.datePicker}
									rightArrowIcon={
										<ArrowForwardIosOutlined className={classes.calendarHeaderButtons} />
									}
									leftArrowIcon={
										<ArrowBackIosOutlined className={classes.calendarHeaderButtons} />
									}
									KeyboardButtonProps={{
										'aria-label': 'Start Date',
										className: classes.calendarButton
									}}
								/>
							</div>
							<div className={clsx([classes.fieldWrapper, 'field-wrapper'])}>
								<TextField
									label="Annual Dues Status"
									variant="filled"
									fullWidth
									disabled
									value={duesValue}
								/>
								</div>*/}
						</div>
					</div>
				) : null}

				<ActivationDialog
					isShown={isActivationDialogShown}
					setIsShown={setIsActivationDialogShown}
					confirmActivation={confirmActivation}
				/>
				<ReactivationDialog
					isShown={isReactivationDialogShown}
					setIsShown={setIsReactivationDialogShown}
					confirmActivation={confirmActivation}
				/>
				<DeactivationDialog
					isShown={isDeactivationDialogShown}
					setIsShown={setIsDeactivationDialogShown}
					confirmDeactivation={confirmDeactivation}
				/>
			</CardContent>
			<CardActions className={classes.actions}>
				<div>
					{firebaseAccountDisabled ? (
						<Button
							variant="outlined"
							color="secondary"
							onClick={handleEnableFirebaseAccount}
							disabled={busy}>
							Enable Firebase Account
						</Button>
					) : null}
					{contact.active ? (
						<Button
							variant="outlined"
							color="secondary"
							onClick={() => sendPasswordReset()}
							disabled={!contact._id}>
							Send Password reset link
						</Button>
					) : null}
					{!contact.primary && !contact.active && contact.activation_id ? (
						<Button
							variant="outlined"
							color="secondary"
							onClick={() => setIsReactivationDialogShown(true)}>
							Reactivate contact
						</Button>
					) : null}
				</div>
				{!contact.primary && contact.active ? (
					<Button
						variant="outlined"
						className={classes.deleteButton}
						onClick={() => setIsDeactivationDialogShown(true)}>
						Deactivate Contact
					</Button>
				) : null}
				{!contact.active && contact._id && !contact.activation_id ? (
					<Button variant="outlined" color="secondary" onClick={() => setIsActivationDialogShown(true)}>
						Activate Contact
					</Button>
				) : null}
				{(!contact.primary && !contact.active && contact.activation_id) || !contact._id ? (
					<Button
						variant="outlined"
						className={classes.deleteButton}
						onClick={() => removeAccount(contact)}>
						Delete contact
					</Button>
				) : null}
			</CardActions>
		</Card>
	)
}

export default withFirebaseHOC(Contact)
